import React from "react";
import "./PriceBlock.css";

export default function PriceBlock({ price, onSelect }) {
  if (!price) return null;
  return (
    <div className="fe2-price">
      <button type="button" className="fe2-price__fav" aria-label="שמירה למועדפים">
        ♡
      </button>
      <strong className="fe2-price__amount fe2-ltr">{price.perPassengerLabel}</strong>
      <span className="fe2-price__per">מחיר לנוסע</span>
      <div className="fe2-price__total">
        <span className="fe2-price__total-amount fe2-ltr">{price.totalLabel}</span>
        <span className="fe2-price__total-note">{price.totalNote}</span>
      </div>
      <button type="button" className="fe2-price__cta" onClick={onSelect}>
        בחר טיסה
      </button>
    </div>
  );
}
